module.exports = __webpack_public_path__ + "static/media/email-white.3dd180cc.svg";